import React from 'react';
/* eslint-disable */
export function ErrorIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M11 0.9375C5.28516 0.9375 0.6875 5.57812 0.6875 11.25C0.6875 16.9648 5.28516 21.5625 11 21.5625C16.6719 21.5625 21.3125 16.9648 21.3125 11.25C21.3125 5.57812 16.6719 0.9375 11 0.9375ZM9.96875 6.78125C9.96875 6.22266 10.3984 5.75 11 5.75C11.5586 5.75 12.0312 6.22266 12.0312 6.78125V12.2812C12.0312 12.8828 11.5586 13.3125 11 13.3125C10.3984 13.3125 9.96875 12.8828 9.96875 12.2812V6.78125ZM11 17.4375C10.2266 17.4375 9.625 16.8359 9.625 16.1055C9.625 15.375 10.2266 14.7734 11 14.7734C11.7305 14.7734 12.332 15.375 12.332 16.1055C12.332 16.8359 11.7305 17.4375 11 17.4375Z"
        fill="currentColor"
      />
    </svg>
  );
}
